import React from "react";
import Sidebar from "../components/sidebar";
import ChatVoiceInterview from "../components/chat-voice-interview";
import UseAnitaChat from "../utils/use-anita-chat";

const ChatAnita = () => {
  const { handleSelectConversation, conversations } = UseAnitaChat();

  return (
    <div className="flex w-full h-screen bg-[#0f1829] overflow-hidden">
      <Sidebar conversations={conversations} handleSelectConversation={handleSelectConversation} />
      <div className="flex-1 overflow-hidden min-w-0">
        <ChatVoiceInterview />
      </div>
    </div>
  );
};

export default ChatAnita;
